import {Injectable} from '@angular/core';

import {Title} from '@angular/platform-browser';
import * as SharedModels from '@shared-models/index';
import {ActivatedRoute, NavigationEnd, Router, RouterEvent} from '@angular/router';
import {filter, map, mergeMap} from 'rxjs/operators';


@Injectable({
    providedIn: 'root'
})
export class AdobeAnalyticsService {

    private readonly analyticsDataLayer: SharedModels.CM.KeyValue = {
        pageInfo: {
            pageName: 'DBadge index page',
            userID: 'jdoe', // User Alias, no domain
            applicationName: 'DBadges/'
        }
    };

    constructor(
        private titleService: Title,
        private router: Router,
        private activatedRoute: ActivatedRoute,
    ) {
        // this.init();
        // this.trackRouteEvents();
    }

    handleTitleForAdobeAnalytics(): void {
        // TODO remove unknown from filter res
        this.router.events
            .pipe(
                filter((event: unknown) => event instanceof NavigationEnd),
                map(() => this.activatedRoute),
                map((route) => {
                    while (route.firstChild) {
                        route = route.firstChild;
                    }
                    return route;
                }),
                filter((route) => route.outlet === 'primary'),
                mergeMap((route) => route.data),

                filter(event => (event.title))
            )
            .subscribe((event) => {
                this.titleService.setTitle(`${'DBadge-'}${event.title}`);
                this.setPageTitle();
                // console.log('route was changed');
                // tslint:disable-next-line: no-string-literal
                if (window['_satellite']) {
                    // tslint:disable-next-line: no-string-literal
                    window['_satellite'].track('pageView');
                }
            });
    }

    init(): void {
        if (window['analyticsDataLayer']) { // tslint:disable-line
            return;
        }

        // bind local value to global scope property (reference by link)
        window['analyticsDataLayer'] = this.analyticsDataLayer; // tslint:disable-line

        if (window['__env'] && window['__env'].analyticsSourceUrl) { // tslint:disable-line
            const script = document.createElement('script');
            script.onload = () => {
                console.log('Adobe Analytics LOADED');
                // run tracking manually
                this.setPageTitle();
                window['_satellite'].track('pageView'); // tslint:disable-line
            };

            script.src = window['__env'].analyticsSourceUrl;  // tslint:disable-line

            document.head.appendChild(script);
        }

    }

    setUserAlias(userAlias: string): void {
        this.analyticsDataLayer.pageInfo.userID = userAlias;
    }

    setPageTitle(): void {
        this.analyticsDataLayer.pageInfo.pageName = this.titleService.getTitle();
    }
}
